module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-03-29-933_com.pinkcoffee.sexbattle.ae3cd511.jpg";